const KEY1 = 'set:feed_setting';

// import {
//     GET_USER_PROFILE ,
//     GET_USER_PROFILE_BY_SLUG ,
// } from '../api/config'
// import * as $http from '../api/fetch'

export const state = () => {
    return {
        feed_setting: {},
    };
};

export const mutations = {
    [KEY1](state, val) {
        state.feed_setting = val;
    },
};

export const actions = {
    [KEY1]({commit}, feed_setting = {}) {
        commit(KEY1, feed_setting)
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};